export default "__VITE_ASSET__CQZbfPg3__"